


























import DatePicker from 'vue-bootstrap-datetimepicker' // TODO: This package requires 'moment', which has large size
import { Mixins } from 'vue-mixin-decorator'
import { Component, Emit, Prop, Watch } from 'vue-property-decorator'

import { DateWithoutHour } from '@/models/date-time/date-without-hour'
import { PluginMixin } from '@spa/mixins/plugin'

@Component({
  components: {
    DatePicker,
  },
})
export default class SelectDeliveryDate extends Mixins<PluginMixin>(
  PluginMixin
) {
  @Prop({ required: true })
  deliverableDates: DateWithoutHour[]

  @Prop({ required: true })
  value: string | null

  datepickerOption = {
    locale: 'ja',
    format: 'YYYY/M/DD',
    useCurrent: 'day',
    minDate: new Date(),
    maxDate: new Date(),
    dayViewHeaderFormat: 'YYYY年 MM月',
    ignoreReadonly: true,
  }

  get ascDeliverableDates(): DateWithoutHour[] {
    return this.deliverableDates.sort((a, b) => {
      return a.valueWithNormalizedHour.getTime() - b.valueWithNormalizedHour.getTime()
    })
  }

  @Watch('deliverableDates')
  setDeliverablePeriod() {
    this.datepickerOption.minDate = this.ascDeliverableDates[0].valueWithNormalizedHour
    this.datepickerOption.maxDate =
      this.ascDeliverableDates[this.ascDeliverableDates.length - 1].valueWithNormalizedHour
  }

  created() {
    this.setDeliverablePeriod()
  }

  /**
   * 現在の選択状態（value）から変わった場合だけ親に通知する。
   * datepickerは、値がクリアされた場合（親がvalueを未選択に戻した場合を含む）にもnullを通知してくる。
   * 未選択も選択状態の一つとして扱う。
   */
  onChange(date: string | null) {
    if (date === this.value) {
      return
    }

    this.changeDeliveryDate(
      date === null ? null : DateWithoutHour.create(date)
    )
  }

  @Emit('change-delivery-date')
  changeDeliveryDate(_d: DateWithoutHour | null) {
    // do nothing
  }

}
